<script setup>
defineProps({
  title: { type: String, default: '' },
  subtitle: { type: String, default: '' },
  minHeight: { type: String, default: '60vh' },
})
</script>

<template>
  <section
    class="flex flex-col items-center justify-center text-center px-4"
    :style="{ minHeight }"
  >
    <div v-if="$slots.illustration" class="mb-6 flex items-center justify-center">
      <slot name="illustration" />
    </div>
    <div
      v-else-if="$slots.icon"
      class="mb-5 flex size-16 items-center justify-center rounded-full bg-surface-2 text-surface-8"
    >
      <slot name="icon" />
    </div>
    <h3
      v-if="$slots.title || title"
      class="text-headline font-semibold text-surface-text-2 !mb-2"
    >
      <slot name="title">{{ title }}</slot>
    </h3>
    <p
      v-if="$slots.subtitle || subtitle"
      class="mb-0 max-w-sm text-tiny leading-snug text-surface-8"
    >
      <slot name="subtitle">{{ subtitle }}</slot>
    </p>
    <div v-if="$slots.actions" class="mt-6 flex w-full flex-col items-center gap-2">
      <slot name="actions" />
    </div>
    <slot />
  </section>
</template>
